import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http';

const getInitialState = (): ModelState => ({
  single: null,
  list: [],
});

const state: ModelState = {
  ...getInitialState(),
};

const getters: GetterTree<ModelState, RootState> = {};

const actions: ActionTree<ModelState, RootState> = {
  fetchList({ commit }, options = {}) {
    return http.v1.boc.fetchList(options).then(({ data }) => {
      commit('SET_STATE', { key: 'list', payload: data.data });

      return {
        items: data.data.data,
        total: data.data.total,
      };
    });
  },
  create({ commit }, { app_name, business_oid }) {
    return http.v1.boc
      .create({
        app_name,
        business_oid,
      })
      .then((response) => {
        commit('SET_STATE', {
          key: 'single',
          payload: response.data.data,
        });
      });
  },
  update({ commit }, { id, payload }) {
    return http.v1.boc
      .update(id, {
        ...payload,
      })
      .then((response) => {
        commit('SET_STATE', {
          key: 'single',
          payload: response.data.data,
        });
      });
  },
  delete(_, { id, business_oid }) {
    return http.v1.boc.delete(id, {
      data: {
        business_oid,
      },
    });
  },
};

const mutations: MutationTree<ModelState> = {
  SET_STATE(state, { key, payload }) {
    state[key] = payload;
  },
  CLEAR_STATE(state, key) {
    state[key] = getInitialState()[key];
  },
  RESET_STATE(state) {
    Object.assign(state, getInitialState());
  },
};

const gst: Module<ModelState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default gst;
